export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="text-2xl font-display text-background-50 whitespace-nowrap">吃瓜爆料</span>
              <p className="mt-3 text-sm text-background-400 leading-relaxed">
                最新吃瓜爆料免费真实资讯平台，实时更新今日吃瓜热点与真实内幕爆料，提供吃瓜爆料最新、免费、真实内容，满足追料需求。
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200">
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                {[
                  { label: '焦点追踪', href: '#carousel' },
                  { label: '视频爆料', href: '#media' },
                  { label: '平台优势', href: '#features' },
                  { label: '热度榜单', href: '#ranking' },
                  { label: '常见问答', href: '#faq' },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">内容分类</h4>
              <div className="flex flex-col gap-2">
                {['明星恋情追踪', '综艺节目内幕', '影视行业深扒', '网红圈风云', '品牌代言博弈'].map((cat) => (
                  <span key={cat} className="text-sm text-background-400 whitespace-nowrap">{cat}</span>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500">合作品牌即将入驻，敬请期待</p>
            </div>
          </div>

          <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2025 吃瓜爆料 版权所有 | 本站内容仅供娱乐参考，不构成任何建议
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-500 whitespace-nowrap">用户协议</span>
              <span className="text-xs text-background-500 whitespace-nowrap">隐私政策</span>
              <span className="text-xs text-background-500 whitespace-nowrap">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}